<template>
  <div
    class="subscribe-content"
    v-loading="loading"
    element-loading-text="加载中..."
  >
    <section>
      <div class="subscribt-btn">
        <el-button
          type="primary"
          @click="addSubscribt"
          style="padding: 10px 14px"
          icon="el-icon-circle-plus-outline"
        >
          添加订阅
        </el-button>
      </div>
      <div class="policy-main" v-if="!noData">
        <div
          class="table-list-item"
          v-for="(item, index) in tableData"
          :key="index"
          @click="policyInfo(item)"
        >
          <div class="policyTitle">
            <h3>
              {{ item.title }}
            </h3>
          </div>
          <div class="list-item-type">
            <small>
              浏览次数：<span>{{ item.readNum || 0 }}</span>
            </small>
            <small>
              政策类别：<span>{{ item.type }}</span>
            </small>
            <small>
              发布日期：<span>{{ item.issueDate }}</span>
            </small>
            <small :title="item.supportIndustry">
              支持产业：<span>{{ item.supportIndustry }}</span>
            </small>
          </div>
          <div class="list-item-type">
            <small>
              申报日期：<span>{{ item.issueDate }}</span>
            </small>
            <small>
              支持力度：<span>{{
                item.supportStrength ? item.supportStrength + "万元" : "--"
              }}</span>
            </small>
            <small>
              发布单位：<span>{{ item.issueDepartment || "--" }}</span>
            </small>
            <small></small>
          </div>
        </div>
      </div>
      <div class="custom-empty" v-else>
        <el-empty
          description="暂未搜索到您订阅的内容，我们会持续补充相关政策......"
          :image="image"
          :image-size="228"
        ></el-empty>
      </div>
      <div style="padding: 0 0 15px; text-align: center" v-if="total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </section>

    <el-dialog
      title="添加订阅"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="policyDialogClose"
      width="576px"
    >
      <div class="dialog-view">
        <el-form
          class="policy-subscribe"
          ref="policyForm"
          :model="policyForm"
          label-position="right"
          label-width="110px"
        >
          <el-form-item label="政策分类：">
            <el-checkbox-group v-model="policyForm.type">
              <el-checkbox
                v-for="item in policyTypeOption"
                :label="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="支持方式：">
            <el-checkbox-group v-model="policyForm.supportWay">
              <el-checkbox
                v-for="item in supporModeList"
                :label="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="dialog-cancel">
          取 消
        </el-button>
        <el-button
          type="primary"
          class="dialog-determine"
          @click="policySubmitForm"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getDropDown } from "@/api/app";
import { updateUserInfo } from "@/api/userCenter";
import { updateSubscribeInfo, myPolicyList } from "@/api/policy";
import { encrypt, FunGetDateStr } from "@/utils/index";
export default {
  data() {
    return {
      dialogVisible: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      tableData: [],
      policyTypeOption: [],
      supporModeList: [],
      noData: false,
      policyForm: {
        type: [],
        supportWay: []
      },
      policySubscribe: false,
      image: require("../../../../assets/noData1.png"),
      state: {
        no: "待领取",
        2: "审核中",
        3: "已通过",
        4: "退回修改"
      }
    };
  },
  components: {},
  computed: {
    ...mapGetters(["user"])
  },
  beforeMount() {
    this.getDropDown("policyType", "policyTypeOption");
    this.getDropDown("supportWay", "supporModeList");
  },
  mounted() {
    if (!this.user.type && !this.user.supportWay) {
      this.$confirm("您还未订阅政策，请先前往完成订阅操作。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showClose: false,
        center: true,
        type: "warning"
      })
        .then(async () => {
          this.dialogVisible = true;
        })
        .catch(() => {});
    } else {
      this.getloadList();
    }
  },
  methods: {
    /**政策已发布状态 */
    getDateState(startTime, endTime, type) {
      if (type == 2) return "申报中";
      const startTime1 = new Date(startTime).getTime();
      const endTime1 = new Date(endTime).getTime();
      let dateTime = new Date(FunGetDateStr(0)).getTime();
      if (dateTime < startTime1) {
        return "即将开始";
      } else if (dateTime > endTime1) {
        return "申报结束";
      } else {
        return "申报中";
      }
    },
    async getloadList() {
      this.loading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: this.user.type,
        supportWay: this.user.supportWay
      };
      let { data } = await myPolicyList(params);
      this.loading = false;
      if (data && data?.records.length > 0) {
        this.tableData = data.records;
        this.total = data.total;
        this.noData = false;
      } else {
        this.noData = true;
        this.total = 0;
      }
    },
    async updateUserInfo() {
      let params = {};
      let { data } = await updateUserInfo(params);
      console.log(data);
    },
    /**政策条件请求 */
    async getDropDown(type, option) {
      let { data } = await getDropDown({ type: type });
      this[option] = data;
    },
    addSubscribt() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.user.type) {
          this.policyForm.type = this.user.type.split(",");
        }
        if (this.user.supportWay) {
          this.policyForm.supportWay = this.user.supportWay.split(",");
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getloadList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getloadList();
    },
    policyDialogClose() {
      this.policyForm = {
        type: [],
        supportWay: []
      };
    },
    async policySubmitForm() {
      let { supportWay, type } = this.policyForm;
      if (supportWay.length <= 0 && type.length <= 0) {
        this.$message({
          message: "请选择订阅信息！",
          type: "warning"
        });
        return;
      }
      let { data } = await updateSubscribeInfo({
        supportWay: supportWay.join(","),
        type: type.join(",")
      });
      if (data) {
        this.$message({
          message: "订阅成功！",
          type: "success"
        });
        await this.$store.dispatch("user/getUserInfo");
        this.dialogVisible = false;
        this.$nextTick(() => {
          this.handleCurrentChange(1);
        });
      }
    },
    policyInfo(item) {
      let { href } = this.$router.resolve({
        path: "/policy/policyInfo",
        query: { id: encrypt(item.id) }
      });
      window.open(href);
    }
  }
};
</script>

<style lang="less" scoped>
.subscribt-btn {
  text-align: right;
  padding: 0 30px;
}
.subscribe-content {
  & > section {
    padding: 20px 0;
    border-radius: 5px;
    background: #fff;
    position: relative;
  }
}
.policy-subscribe {
  ::v-deep {
    .el-form-item__content,
    .el-form-item__label {
      line-height: 28px;
    }
  }
}
.policy-main-scroll {
  padding: 0 30px;
}
.policy-main {
  height: 100%;
  padding: 30px;
}
.policy-item {
  border-bottom: 1px solid rgba(235, 235, 235, 0.83);
  display: flex;
  align-items: center;
  color: #312f2f;
  padding: 0px 30px;
  & small {
    padding: 14px 0;
    font-size: 14px;
    width: 0;
    flex: 1;
    margin-right: 20%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &:hover {
      color: #1d6cea;
      cursor: pointer;
    }
  }
}
.table-list-item {
  border: 1px solid #eeeeee;
  margin-bottom: 20px;
  padding: 20px;
  cursor: pointer;
  &:hover {
    background: rgba(243, 249, 254, 1);
    & h3 {
      color: rgba(22, 96, 212, 1);
    }
  }
  & h3 {
    color: rgba(49, 47, 47, 1);
    font-size: 16px;
    margin: 0;
    &:hover {
      cursor: pointer;
    }
  }
  & .list-item-type {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 15px;
    &:last-of-type {
      padding-bottom: 0;
    }
    small {
      width: 25%;
      flex: 1;
      font-size: 14px;
      color: rgba(169, 169, 169, 1);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    span {
      color: rgba(49, 47, 47, 1);
    }
  }
}
.policyTitle {
  padding-bottom: 15px;
}
</style>
